document.addEventListener('DOMContentLoaded', function() {
  // Initialize all Arauris Posts Carousels on the page
  const carousels = document.querySelectorAll('.arauris-posts-splide');

  carousels.forEach(function(carousel) {
    initializeCarousel(carousel);
  });

  // Reinitialize carousels when sections are reloaded in theme editor
  document.addEventListener('shopify:section:load', function(event) {
    const carouselsInSection = event.target.querySelectorAll('.arauris-posts-splide');
    carouselsInSection.forEach(function(carousel) {
      initializeCarousel(carousel);
    });
  });
});

function initializeCarousel(carouselElement) {
  // Get section settings from the element's section
  const section = carouselElement.closest('.arauris-posts-carousel');
  if (!section) return;

  // Extract settings from data attributes (these would be set via Liquid)
  const sectionId = carouselElement.id.replace('arauris-posts-', '');
  const settingsScript = document.querySelector(`#carousel-settings-${sectionId}`);

  // Default settings
  let settings = {
    postsPerPage: 3,
    postsPerPageMobile: 1,
    showPagination: true,
    autoplay: false,
    autoplaySpeed: 5000
  };

  // Override with section settings if available
  if (settingsScript) {
    try {
      const sectionSettings = JSON.parse(settingsScript.textContent);
      settings = { ...settings, ...sectionSettings };
    } catch (e) {
      console.warn('Failed to parse carousel settings:', e);
    }
  }

  // Determine responsive breakpoints
  const isMobile = window.innerWidth <= 767;
  const perPage = isMobile ? settings.postsPerPageMobile : settings.postsPerPage;

  // Splide configuration
  const splideConfig = {
    type: 'loop',
    perPage: perPage,
    perMove: 1,
    gap: '2rem',
    padding: {
      left: '2rem',
      right: '2rem'
    },
    breakpoints: {
      767: {
        perPage: settings.postsPerPageMobile,
        gap: '1rem',
        padding: {
          left: '1rem',
          right: '1rem'
        }
      },
      1024: {
        perPage: Math.min(settings.postsPerPage, 2),
        gap: '1rem'
      }
    },
    arrows: false,
    pagination: settings.showPagination,
    autoplay: settings.autoplay,
    interval: settings.autoplaySpeed,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: false,
    rewind: true,
    focus: 0,
    trimSpace: false,
    classes: {
      pagination: 'splide__pagination',
      page: 'splide__pagination__page'
    }
  };

  // Initialize Splide
  try {
    const splide = new Splide(carouselElement, splideConfig);
    // Mount the carousel
    splide.mount();

    // Handle responsive changes
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const newIsMobile = window.innerWidth <= 767;
        const newPerPage = newIsMobile ? settings.postsPerPageMobile : settings.postsPerPage;

        // Update configuration if screen size category changed
        if (newIsMobile !== isMobile) {
          splide.options = {
            perPage: newPerPage
          };
          splide.refresh();
        }
      }, 250);
    });

    // Store the splide instance for potential cleanup
    carouselElement.splideInstance = splide;

  } catch (error) {
    console.error('Failed to initialize Arauris Posts Carousel:', error);

    // Fallback: show all slides in a grid if Splide fails
    const track = carouselElement.querySelector('.splide__track');
    const list = carouselElement.querySelector('.splide__list');

    if (track && list) {
      track.style.overflow = 'visible';
      list.style.display = 'grid';
      list.style.gridTemplateColumns = `repeat(auto-fit, minmax(280px, 1fr))`;
      list.style.gap = '2rem';
      list.style.transform = 'none';

      // Hide navigation elements
      const pagination = carouselElement.querySelector('.splide__pagination');
      if (pagination) pagination.style.display = 'none';
    }
  }
}

// Cleanup function for theme editor
document.addEventListener('shopify:section:unload', function(event) {
  const carouselsInSection = event.target.querySelectorAll('.arauris-posts-splide');
  carouselsInSection.forEach(function(carousel) {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
      carousel.splideInstance = null;
    }
  });
});

// Helper function to get section settings (if needed)
function getSectionSettings(sectionElement) {
  const settingsElement = sectionElement.querySelector('[data-section-settings]');
  if (settingsElement) {
    try {
      return JSON.parse(settingsElement.getAttribute('data-section-settings'));
    } catch (e) {
      console.warn('Failed to parse section settings:', e);
    }
  }
  return {};
}